
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Enum.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

export enum EntityChangeLogMetaDataType {
	None = 0,
	AccountingPlanAutoRenewed = 1,
	AccountingPlanAutoRenewedWithPriceAdjustment = 2,
	AccountingPlanBulkAdjusted = 3,
	AccountingPlanEndedEarly = 4,
	AccountingPlanUpgraded = 5,
	AccountingPlanAnnuallyPriceAdjusted = 6,
	AccountingPlanUpdated = 7,
	AccountingPlanRegisterDelivery = 8,
	AccountingPlanStarted = 9,
	AccountingPlanCancelled = 10,
	AccountingPlanCompanyTransfer = 11,
	OrderApproved = 12,
	OrderWarningCreated = 13,
	OrderWarningRemoved = 14,
	OrderCancelled = 15,
	AccountingPlanAutoRenewedWithAnnualAdjustmentPercent = 16
}
export namespace EntityChangeLogMetaDataType {
	export function getKeys(): Map<EntityChangeLogMetaDataType, string> {
		return new Map([[0, 'None'], [1, 'AccountingPlanAutoRenewed'], [2, 'AccountingPlanAutoRenewedWithPriceAdjustment'], [3, 'AccountingPlanBulkAdjusted'], [4, 'AccountingPlanEndedEarly'], [5, 'AccountingPlanUpgraded'], [6, 'AccountingPlanAnnuallyPriceAdjusted'], [7, 'AccountingPlanUpdated'], [8, 'AccountingPlanRegisterDelivery'], [9, 'AccountingPlanStarted'], [10, 'AccountingPlanCancelled'], [11, 'AccountingPlanCompanyTransfer'], [12, 'OrderApproved'], [13, 'OrderWarningCreated'], [14, 'OrderWarningRemoved'], [15, 'OrderCancelled'], [16, 'AccountingPlanAutoRenewedWithAnnualAdjustmentPercent']]);
	}
}
